import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LegalMentionsLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.legal_notice',
    link: '/informations-legales',
    icon: 'navigation-link__legal-mentions',
});